// extracted by mini-css-extract-plugin
export var actions = "_gd-g";
export var benefitCard = "_gd-b";
export var benefitIcon = "_gd-d";
export var benefitLabel = "_gd-f";
export var benefits = "_gd-a";
export var benefitsSection = "_gd-8";
export var bodyText = "_gd-7";
export var closeButton = "_gd-2";
export var content = "_gd-3";
export var eyebrow = "_gd-4";
export var heading = "_gd-5";
export var image = "_gd-i";
export var imagePanel = "_gd-h";
export var modal = "_gd-0";
export var offerCard = "_gd-c";
export var offerIcon = "_gd-e";
export var sectionLabel = "_gd-9";
export var shell = "_gd-1";
export var title = "_gd-6";